'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.quiz', {
    url: '/quizzes/:quizType',
    resolve: {
      quiz: function ($q, $stateParams, module) {
        return module.quizzes[$stateParams.quizType] || $q.reject({ status: 404 });
      }
    },
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/quiz/quiz.html',
        controller: function ($scope, $state, Api, module, quiz) {
          $scope.module = module;
          $scope.quiz = quiz;

          Api.track('module.quiz', 'view');

          $scope.current = 0;
          $scope.question = quiz.questions[$scope.current];

          $scope.prev = function () {
            if ($scope.current === 0) {
              $state.go('^', {}, { reload: true });
            } else {
              $scope.current--;
              $scope.question = quiz.questions[$scope.current];
            }
          };

          $scope.next = function () {
            if ($scope.question.response) {
              if ($scope.quiz.passed) {
                //This strange logic is described in the doc block in $scope.reply()
                Api.track('module.quiz.question', 'pass', { questionId: $scope.question._id }, { answerId: $scope.question.response });
              }
              if ($scope.current === quiz.questions.length - 1) {
                quiz.answered = _.map(quiz.questions, function (q) {
                  return _.find(q.answers, { _id: q.response });
                });
                $state.go('.results');
              } else {
                $scope.current++;
                $scope.question = quiz.questions[$scope.current];
              }
            }
          };

          $scope.reply = function (answer) {
            $scope.question.response = answer._id;
            if (!$scope.quiz.passed) {
              /**
               * When user reviews the completed quiz and changes the answer >> Don't take him to the next question automatically.
               * Let him see his new choice and click Next.
               * If he doesn't click Next and just closes the view don't save this new data.
               */
              Api.track('module.quiz.question', 'pass', { questionId: $scope.question._id }, { answerId: answer._id });
              $scope.next();
            }
          };

        }
      }
    }
  });

  $stateProvider.state('instance.app.module.quiz.results', {
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/quiz/quizResults.html',
        controller: function ($scope, $state, $stateParams, Api, module, quiz) {
          $scope.module = module;
          $scope.quiz = quiz;
          $scope.quizType = $stateParams.quizType;
          $scope.score = _(quiz.answered).filter('value', 1).size();
          $scope.maxScore = quiz.questions.length;
          $scope.result = _.find(quiz.response.responses, function (response) {
            return response.values.min <= $scope.score && response.values.max >= $scope.score;
          });
          var incorrectAnswers = _.filter(quiz.answered, 'value', 0);
          $scope.incorrectQuestions = _(quiz.questions).filter(function (q, idx) {
            var intersection = _.intersection(_.map(q.answers, '_id'), _.map(incorrectAnswers, '_id'));
            if (intersection.length && q.lesson) {
              q.index = idx;
              var lesson = _.find(module.lessons, {_id: q.lesson});
              q.lessonName = 'Lesson ' + lesson.index + ': ' + lesson.name;
              q.byteName = _.find(lesson.learningBytes, {_id: q.byte}).name;
              q.correctAnswer = _.find(q.answers, {value: 1});
              return q;
            }
            return false;
          }).value();
          $scope.userAnswers = quiz.answered;

          Api.track('module.quiz', 'pass', {}, { result: $scope.score / $scope.maxScore });

          $scope.continue = function () {
            if ($scope.quizType == 'post') {
              $state.go('^.^.recap', {}, { reload: true });
            } else {
              $state.go('^.^', { expandedLessonId: module.lessons[0]._id }, { reload: true });
            }
          };
        }
      }
    }
  });
});
